import styled from 'styled-components';

import {
  gemAnimation,
  reversedGemAnimation,
} from '@/modules/jackpot/components/JackpotGemsPack/styled';
import { device } from '@/styles/helpers';

export interface ScBackgroundProps {
  withMessage: boolean;
}

export const ScBackground = styled.div<ScBackgroundProps>`
  position: absolute;
  inset: 0;
  bottom: auto;
  z-index: -2;
  margin-top: -96px;
  overflow: hidden;

  & > .bg {
    position: relative;
    width: 100%;
    height: ${({ withMessage }) => (withMessage ? '578px' : '506px')};

    & > img {
      object-fit: cover;
      object-position: top center;
    }
  }

  & > .round-decor {
    width: 100%;
    height: 24px;
    border-radius: 24px 24px 0 0;
    background-color: ${({ theme }) => theme.blackColor};
    margin-top: -24px;
    position: absolute;
    z-index: 1;
  }

  .pink,
  .blue,
  .green,
  .bluredBlue,
  .bluredGreen,
  .bluredPink {
    position: absolute;
    aspect-ratio: 1/1;
  }

  .pink {
    width: 200px;
    bottom: 80px;
    left: 210px;
    z-index: 2;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  .blue {
    width: 170px;
    top: 80px;
    left: 65px;
    z-index: 2;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .green {
    width: 160px;
    top: 166px;
    right: 180px;
    z-index: 2;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .bluredPink {
    width: 470px;
    top: 26px;
    right: -130px;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  .bluredBlue {
    width: 450px;
    bottom: -170px;
    left: 160px;
    animation: ${gemAnimation} infinite 7s ease-out;
    z-index: 0;
  }

  .bluredGreen {
    width: 310px;
    top: -90px;
    left: 140px;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  @media (${device.mobile}) {
    & > .bg {
      height: 690px;
    }

    .pink,
    .green,
    .bluredBlue,
    .bluredGreen {
      position: absolute;
      aspect-ratio: 1/1;
    }

    .blue,
    .bluredPink {
      display: none;
    }

    .pink {
      bottom: auto;
      top: -60px;
      left: -75px;
    }

    .green {
      top: 180px;
      right: -75px;
    }

    .bluredBlue {
      bottom: 60px;
      left: auto;
      right: -200px;
    }

    .bluredGreen {
      top: 310px;
      left: -200px;
    }
  }
`;
